

import './button.component.scss'
import { Loader } from '../';

const Button = ({isLoading, className , children, onClick, type='button', disabled, ...props}) =>
(<button {...props} {...{type}} className={`button-component btn btn-default virgin-button ${className ?? ''}`} disabled={isLoading || disabled} {...{onClick}}>{children} {isLoading && <Loader className='button-component__loader' />}</button>);

export default Button;